import { USER_CUSTOMERS_ERR_MSG_EMPTY } from 'constants/validMsg';
import * as TY from 'containers/pages/contacts/constants';
import { initContact } from 'containers/pages/contacts/data';
import validateEmail from 'libs/validations/validateEmail';
import validateFirstName from 'libs/validations/validateFirstName';
import validateLastName from 'libs/validations/validateLastName';

/**
 * @function handleContact
 * @param {*} e
 * @param {*} payload
 * @param {function} dispatch
 * @param {string} addressType
 * @param {function} setValid
 * @param {function} setCanNotSave
 * @param {Contact} contact
 * @returns {void}
 */
function handleContact(e, payload, dispatch, addressType, setValid, contact) {
	const name = e.target.name.trim();

	switch (name) {
		case TY.FIRST_NAME:
			const _fname = validateFirstName(e.target.value);
			if (_fname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.FIRST_NAME]: { isErr: true, errMsg: _fname.errMsg, canNotSave: true },
				}));
			} else if (!_fname.isErr && contact[TY.FIRST_NAME] === '') {
				setValid((prev) => ({
					...prev,
					[TY.FIRST_NAME]: { isErr: false, errMsg: '', canNotSave: true },
				}));
			} else if (!_fname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.FIRST_NAME]: { isErr: false, errMsg: '', canNotSave: false },
				}));
			}
			return dispatch({ type: TY.FIRST_NAME, payload: e.target.value });
		case TY.LAST_NAME:
			const _lname = validateLastName(e.target.value);
			if (_lname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.LAST_NAME]: { isErr: true, errMsg: _lname.errMsg, canNotSave: true },
				}));
			} else if (!_lname.isErr && contact[TY.LAST_NAME] === '') {
				setValid((prev) => ({
					...prev,
					[TY.LAST_NAME]: { isErr: false, errMsg: '', canNotSave: true },
				}));
			} else if (!_lname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.LAST_NAME]: { isErr: false, errMsg: '', canNotSave: false },
				}));
			}
			return dispatch({ type: TY.LAST_NAME, payload: e.target.value });

		case TY.COMPANIES:
			if (payload.length === 0) {
				setValid((prev) => ({
					...prev,
					[TY.COMPANIES]: { isErr: true, errMsg: USER_CUSTOMERS_ERR_MSG_EMPTY, canNotSave: true },
				}));
			} else {
				setValid((prev) => ({
					...prev,
					[TY.COMPANIES]: { isErr: false, errMsg: '', canNotSave: false },
				}));
			}
			return dispatch({ type: TY.COMPANIES, payload: payload });

		case TY.EMAIL_WORK:
			const _emailWork = validateEmail(e.target.value);
			setValid((prev) => ({
				...prev,
				[TY.EMAIL_WORK]: {
					isErr: _emailWork.isErr,
					errMsg: _emailWork.errMsg,
					canNotSave: _emailWork.isErr ? true : false,
				},
			}));
			return dispatch({ type: TY.EMAIL_WORK, payload: e.target.value });
		case TY.EMAIL_PERSONAL:
			const _emailPersonal = validateEmail(e.target.value);
			setValid((prev) => ({
				...prev,
				[TY.EMAIL_PERSONAL]: {
					isErr: _emailPersonal.isErr,
					errMsg: _emailPersonal.errMsg,
					canNotSave: _emailPersonal.isErr ? true : false,
				},
			}));
			return dispatch({ type: TY.EMAIL_PERSONAL, payload: e.target.value });
		case TY.EMAIL_OTHER:
			const _emailOther = validateEmail(e.target.value);
			setValid((prev) => ({
				...prev,
				[TY.EMAIL_OTHER]: {
					isErr: _emailOther.isErr,
					errMsg: _emailOther.errMsg,
					canNotSave: _emailOther.isErr ? true : false,
				},
			}));
			return dispatch({ type: TY.EMAIL_OTHER, payload: e.target.value });
		case TY.CONTACT_POSITION:
			return dispatch({ type: TY.CONTACT_POSITION, payload: e.target.value });


		// case TY.CONTACT_TYPES:
		// 	if (payload.length === 0) {
		// 		setValid((prev) => ({
		// 			...prev,
		// 			[TY.CONTACT_TYPES]: {
		// 				isErr: true,
		// 				errMsg: USER_CONTACTTYPES_ERR_MSG_EMPTY,
		// 				canNotSave: true,
		// 			},
		// 		}));
		// 	} else {
		// 		setValid((prev) => ({
		// 			...prev,
		// 			[TY.CONTACT_TYPES]: { isErr: false, errMsg: '', canNotSave: false },
		// 		}));
		// 	}
		// 	return dispatch({ type: TY.CONTACT_TYPES, payload: payload });
		case TY.PHONE_WORK:
			return dispatch({ type: TY.PHONE_WORK, payload: payload });
		case TY.PHONE_MOBILE:
			return dispatch({ type: TY.PHONE_MOBILE, payload: payload });
		case TY.PHONE_OTHER:
			return dispatch({ type: TY.PHONE_OTHER, payload: payload });
		case TY.UNIT:
			if (addressType === TY.ADDRESS_WORK) {
				return dispatch({ type: TY.ADDRESS_WORK_UNIT, payload: e.target.value });
			} else if (addressType === TY.ADDRESS_HOME) {
				return dispatch({ type: TY.ADDRESS_HOME_UNIT, payload: e.target.value });
			} else if (addressType === TY.ADDRESS_OTHER) {
				return dispatch({ type: TY.ADDRESS_OTHER_UNIT, payload: e.target.value });
			}
			break;
		case TY.RESET:
			dispatch({ type: TY.RESET, payload: initContact });
			return;
		case TY.NOTE_RESET:
			return dispatch({ type: TY.NOTE_RESET });
		default:
			return dispatch({ type: e.target.name, payload: e.target.value });
	}
}

export default handleContact;
